document.addEventListener('alpine:init', () => {
  Alpine.data(
    'Theme_ProductSlider',
    ({
      perPage=4,
      autoplay = false,
      autoplayInterval = null,
      mode = 'slideshow',
      gap=0,
      pagination = true,
      onlyIfNeeded=true,
      arrows = true,
      overrideOptions = {},
    }) => ({
      autoplay,
      autoplayInterval,
      playing: false,
      splide: null,
      rate: 0,
      mode,
      gap,
      onlyIfNeeded,
      maxLgBreakpointMQL: window.matchMedia('(min-width: 450px)'),
      progress: 0,
      init() {
        if (typeof Splide === 'undefined') {
          console.error(
            'slideshows.js requires a Splide object to be defined in the global scope'
          );

          return;
        }

        this.initSplide();

        if (this.onlyIfNeeded) {
          this.destroyOrInitIfNeeded();
           this.maxLgBreakpointMQL.addEventListener('change', (e) => {
            this.destroyOrInitIfNeeded();
          });
        }

        if (Shopify.designMode) {
          this._setUpDesignModeHandlers();
        }

        document.addEventListener('dev:hotreloadmutation', async () => {
          if (!Shopify.designMode) {
            this.splide.destroy();

            await this.$nextTick();

            this.initSplide();
          }
        });
      },
      initSplide() {
        const options = {
          arrows: this.arrows,
          pagination: this.pagination,
          waitForTransition: false,
          rewind: false,
          speed: 600,
          start: parseInt(this.$root.dataset.start, 10) - 1 || 0,
          interval: this.autoplayInterval,
          autoplay: this.autoplay,
          drag: !this.autoplay,
          mediaQuery: 'min',
          ...overrideOptions,
        };
        if (this.mode === 'carousel') {
          options.autoWidth = true;
        }

        if (this.gap) {
          options.gap = this.gap;
        }

        this.splide = new Splide(this.$root, options);
        const _that = this;
        this.splide.on('mounted move', (...args)=>{
            const perPage = _that.splide.options.perPage;
            const end  = _that.splide.Components.Controller.getEnd();
            const rate = Math.min(  _that.splide.index / end, 1 );
            _that.progress = 100 * rate;
        });
        if(options.drag == 'free'){
          this.splide.on('dragged', (...args)=>{
            const perPage = _that.splide.options.perPage;
            const end  = _that.splide.Components.Controller.getEnd();
            const rate = Math.min(  _that.splide.index / end, 1 );
            _that.progress = 100 * rate;
        })
        }
        if (options.autoplay) {
          this.splide.on('autoplay:play', () => {
            this.playing = true;
          });

          this.splide.on('autoplay:pause', () => {
            this.playing = false;
          });

          this.splide.on('autoplay:playing', (rate) => {
            this.rate = rate;
          });
        }

        this.splide.mount();
      },
      destroyOrInitIfNeeded() {
        if (splideIsNotDestroyed(this.splide) && !this.maxLgBreakpointMQL.matches) this.splide.destroy();
        const slideEls = Array.from(
          this.$root.querySelectorAll('.splide__slide')
        );

        const totalSlidesWidth = slideEls.reduce(
          (totalWidth, slideEl) =>
            totalWidth + slideEl.getBoundingClientRect().width,
          0
        );

        const totalGridlinesWidth =
          parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue(
              '--gridline-width'
            )
          ) *
          (slideEls.length - 1);

        const totalContentWidth = totalSlidesWidth + totalGridlinesWidth;

        if (totalContentWidth <= this.$root.getBoundingClientRect().width) {
          if (splideIsNotDestroyed(this.splide)) this.splide.destroy();
        } else {
          if (!splideIsNotDestroyed(this.splide)) this.initSplide();
        }
      },
      _setUpDesignModeHandlers() {
        this.$root.addEventListener('slideshow-go', (e) => {
          if (!e.detail) return;

          this.splide.go(parseInt(e.detail, 10));
        });
      },
    })
  );
});
